import { useSelector } from 'react-redux';

import useOrgConfig from './useOrgConfig';
import { selectIsUserSuperAdmin } from 'src/reducers/userReducer/userReducer';

const useDiscoverSectionViewable = () => {
  const isSuperAdmin = useSelector(selectIsUserSuperAdmin);
  const { discover_viewable_tier } = useOrgConfig();

  const discoverAnalyticsEnabled = ['pro', 'enterprise'].includes(
    discover_viewable_tier ?? '',
  );

  const showInternalBadgeForAnalytics =
    !discoverAnalyticsEnabled && isSuperAdmin;

  const discoverActionsEnabled = discover_viewable_tier === 'enterprise';

  const showInternalBadgeForActions = !discoverActionsEnabled && isSuperAdmin;

  return {
    discoverActionsEnabled: discoverActionsEnabled || isSuperAdmin,
    discoverAnalyticsEnabled: discoverAnalyticsEnabled || isSuperAdmin,
    showInternalBadgeForActions,
    showInternalBadgeForAnalytics,
  };
};

export default useDiscoverSectionViewable;
